var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-form-dialog", {
    ref: "refBaseCard",
    attrs: {
      formOptionNumTemp: "7",
      "is-form": "",
      "is-show-close": "",
      title: "身份证识别",
      width: "35%",
    },
    on: { onSendFileList: _vm.onGetFileList, onUploadAfter: _vm.onUploadAfter },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }